import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nextToPromise } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ViajeZEForm } from "./form";
const ViajeZEFormRx = componentToRx(ViajeZEForm);
type Entity = models.ViajeZE;
const resource = resources.ViajeZE;

interface Props {
    match: match<{ id: string }>
}
class ViajeZEEditComp extends React.PureComponent<Props> {
    idStr = (props: Props) => this.props.match.params.id;
    id = createSelectorRx(this.idStr, id => id == "new" ? "new" : Number.parseInt(id));
    value = createSelectorRx(this.id, id => observeResource(resource.GetViaje, id));

    render() {
        const value = this.value(this.props);
        const id = this.id(this.props);
        return <ViajeZEFormRx value={value} />;
    }
}

export const ViajeZEEdit = withRouter(ViajeZEEditComp);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesZE/edit/index.tsx